export enum AddUserTab {
  Configure = 0,
  Roles = 1,
  Groups = 2,
  Licenses = 3,
  Content = 4,
  Notify = 5,
}
